import React from 'react';
import logo from "../../img/logo.png";

function Sidebar({ active, sideBarMenu = [], handleSidebar, isOpen = false, onClose }) {
  return (
    <>
      {/* Backdrop for mobile drawer — sits above header (z-50) */}
      {isOpen && (
        <div
          className="lg:hidden fixed inset-0 z-[55] bg-slate-900/50 backdrop-blur-sm"
          onClick={onClose}
        />
      )}

      <aside
        className={`
          flex flex-col bg-custom-pink border-r border-slate-200
          fixed inset-y-0 left-0 z-[60] w-64
          transform transition-transform duration-300 ease-in-out
          ${isOpen ? 'translate-x-0' : '-translate-x-full'}
          lg:relative lg:translate-x-0 lg:z-auto
          lg:min-w-[16rem] lg:w-[16rem]
        `}
      >
        {/* Header with Logo + close (mobile only) */}
        <div className="p-6 mb-2 flex items-center justify-between">
          <img src={logo} alt="Rize Mortgage" className="w-28 lg:w-32" />
          <button
            onClick={onClose}
            className="lg:hidden group relative w-9 h-9 flex items-center justify-center rounded-full bg-white/60 text-slate-500 hover:bg-orange-500 hover:text-white hover:shadow-md hover:shadow-orange-300/40 active:scale-90 transition-all duration-300 ease-out"
            aria-label="Close menu"
          >
            <svg
              className="w-4 h-4 transition-transform duration-300 ease-out group-hover:rotate-90"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              strokeWidth={2.5}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
            <span className="absolute inset-0 rounded-full ring-2 ring-orange-300/0 group-hover:ring-orange-300/40 transition-all duration-300" />
          </button>
        </div>

        {/* Navigation Links */}
        <div className="flex-1 px-4 py-2 overflow-y-auto">
          {sideBarMenu.length > 0 && (
            <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-4 px-3">
              Administration
            </div>
          )}

          <ul className="space-y-3">
            {sideBarMenu.map(item => {
              const isActive = active === item.name;
              return (
                <li key={item.name}>
                  <button
                    onClick={() => handleSidebar(item.name)}
                    aria-current={isActive ? 'page' : undefined}
                    className={`group w-full flex items-center gap-4 px-5 py-4 rounded-2xl text-left transition-all duration-200 ${
                      isActive
                        ? 'bg-[#fb6635] text-white shadow-md shadow-orange-300/40'
                        : 'text-[#0a1445] hover:bg-[#f5703a] hover:text-white hover:shadow-md hover:shadow-orange-300/40'
                    }`}
                  >
                    <span className={`flex-none ${isActive ? 'text-white' : 'text-[#0a1445] group-hover:text-white'}`}>
                      {item.icon}
                    </span>
                    <span className={`text-sm ${isActive ? 'font-semibold' : 'font-medium'}`}>
                      {item.name}
                    </span>
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      </aside>
    </>
  );
}

export default Sidebar;
